<template lang="html">
  <fullscreen-overlay-layout
    @close="closeOverlay"
    :title="getCurrentRT.title"
  >
    <div class="tl w-100">
      <pl-button
        v-if="submission.user"
        @click.native="closeOverlay"
        class="pl-secondary-font"
      >
        In response to {{ submission.user.name }}'s submission
      </pl-button>
    </div>
    <comment-card-list
      :submissionID="submissionID"
      :listOfComments="filteredCommentsToShow"
      :commentToAutoExpandID="topLevelCommentID"
      :commentReplyToHighlightID="replyCommentID"
      :smallFont="true"
    />
  </fullscreen-overlay-layout>
</template>
<script>
  import { mapGetters } from 'vuex';
  import SubmissionCardHeader from './submissionCard/cardHeader';
  import SubmissionResponseText from './submissionResponseText';
  import CommentCardList from './commentCardList';
  import CommentCard from './commentCard/commentCard';
  import FullscreenOverlayLayout from 'components/fullscreenOverlay';

  export default {
    data() {
      return {
        show_all_comments: false,
      };
    },
    components: {
      SubmissionCardHeader,
      SubmissionResponseText,
      FullscreenOverlayLayout,
      CommentCardList,
      CommentCard,
    },
    computed: {
      ...mapGetters(['getCurrentRT']),
      replyCommentID() {
        return this.$route.query.replyCommentID;
      },
      topLevelCommentID() {
        return this.$route.query.topLevelCommentID;
      },
      submissionID() {
        return this.$route.query.submissionID;
      },
      commentsToShow() {
        return this.submission.comments || [];
      },
      filteredCommentsToShow() {
        return this.show_all_comments
          ? this.commentsToShow
          : this.commentsToShow.filter(
              (comment) => comment.id === this.topLevelCommentID
            );
      },
    },
    methods: {
        closeOverlay() {
        this.$store.dispatch('userEnteredSummaryOverlay', false);
        this.$emit('close',{ submissionID: this.submission.id });
      }
    },
    props: {
      submission: {
        type: Object,
        default() {
          return {
            flagged_by: [],
            user: {
              name: null,
              avatar_url: null,
            },
            start_date: null,
          };
        },
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// individualReplyOverlay.vue?1eaad3f4